import React from 'react';
import './Header.css'
import { Link } from "react-router-dom";
import { wordpressRoot } from '../../configFile';
export default function Header() {
  
  return (
    <>
      <div className='header'>
        <Link to="/">
          <img src={window.location.origin + wordpressRoot +  'wp-content/uploads/2024/04/logo_passion_musique.png'} alt='logo' className='logo'/>
        </Link>
        <div className='pages-nav'>
          <Link to="/">Accueil</Link>
          <Link to="/cours/">Cours</Link>
          <Link to="/orchestre/">Orchestre</Link>
          <Link to="/animations/">Animations</Link>
          {/* <Link to="/contact/">Contact</Link> */}
        </div>
      </div>
      <div className='phone-number-header'>
        <a href='tel:0660486904'>06.60.48.69.04</a>
        <a href='mailto:passion-musique@gmail.com'><br/>passion-musique@gmail.com</a>
      </div>
    </>
  )
}
